import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe('pk_live_51OItxMJRzxFbwVBPK9I26AS9xpMNMbo0ovz48vfltAdVbLxaIn1hrto0IUY4pSOMXszu7f2Jv6fL28sISiWeYDcj00G4cWLOhB');